var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidaymainmoduledarkpurpleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 37,
    viewBox: "0 0 47 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2872 9.78458L31.0259 12.4418C28.5235 6.6142 24.8953 2.12948 21.1413 0.0275651C27.9596 -0.321921 34.5659 2.66908 38.8149 8.01786C39.2906 8.6182 39.004 9.52229 38.2872 9.78458ZM28.8826 13.2266L11.9237 19.4323C9.38072 10.7573 10.5939 2.87563 14.9552 1.28043C15.4815 1.08746 16.0312 0.994548 16.5972 0.994548C20.7232 0.995262 25.7188 5.93809 28.8826 13.2266ZM9.40845 4.32431C8.96613 5.48927 8.63831 6.79716 8.46977 8.26871C8.06158 11.8343 8.57075 16.0039 9.81735 20.2027L2.51979 22.8728C1.80226 23.1351 1.00438 22.6277 0.985889 21.8601C0.820908 15.0212 3.96622 8.46383 9.40845 4.32431ZM6.6692 32.0173H23.6608L19.0428 19.2614L23.3195 17.6963L28.5036 32.0166H45.3544C45.983 32.0166 46.4922 32.5283 46.4922 33.1608V35.4486C46.4922 36.0804 45.983 36.5928 45.3544 36.5928H6.6692C6.04057 36.5928 5.5314 36.0804 5.5314 35.4486V33.1608C5.5314 32.529 6.04057 32.0173 6.6692 32.0173Z",
    fill: "#321E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidaymainmoduledarkpurpleicon);
export default __webpack_public_path__ + "static/media/holiday main module dark purple icon.a72971186e00f3ec0940bd2b3e438321.svg";
export { ForwardRef as ReactComponent };